import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const whatIsSectionStyles = {
  contentWrapper: (isSingleEntity: boolean): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: isSingleEntity
      ? "1fr"
      : { xs: "1fr", lg: "repeat(2, 1fr)" },
    gap: { xs: 6, lg: 8 },
    mt: 6,
    justifyItems: isSingleEntity ? "center" : "stretch",
  }),
  card: (theme: Theme): SystemStyleObject<Theme> => ({
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    p: { xs: 4, md: 6 },
    display: "flex",
    flexDirection: "column",
    gap: 3,
    width: "100%",
  }),
  cardTitle: (theme: Theme): SystemStyleObject<Theme> => ({
    fontSize: { xs: 24, md: 28 },
    fontWeight: 700,
    color: theme.palette.secondary.main,
  }),
  logoWrapper: (): SystemStyleObject<Theme> => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 150,
    my: 2,
    overflow: "hidden",

    "& img": {
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
    },
  }),
  cardDescription: (): SystemStyleObject<Theme> => ({
    fontSize: { xs: 14, md: 16 },
    lineHeight: 1.7,
    color: "grey.400",
    fontWeight: 400,
  }),
};

export default whatIsSectionStyles;
